export const PERMISSION_BUNDLES = {
  TICKET_SUBMIT: {
    label: 'pages.clientCredentialsPage.permissions.ticketSubmit',
    defaultLabel: 'Ticket Submission',
    icon: 'solar:file-send-bold-duotone',
    permissions: ['TICKET:CREATE', 'FILE:UPLOAD'],
  },
  TICKET_RESOLVE: {
    label: 'pages.clientCredentialsPage.permissions.ticketResolve',
    defaultLabel: 'Ticket Resolution',
    icon: 'solar:check-read-bold-duotone',
    permissions: [
      'TICKET:READ',
      'TICKET:UPDATE',
      'TICKET:RESOLVE',
      'TICKET_COMMENT:CREATE',
      'TICKET_COMMENT:READ',
      'TICKET_STATUS:READ',
      'TICKET_ASSIGNEES:CREATE',
      'TICKET_ASSIGNEES:READ',
      'TICKET_ASSIGNEES:UPDATE',
    ],
  },
  TICKET_DELETE: {
    label: 'pages.clientCredentialsPage.permissions.ticketDelete',
    defaultLabel: 'Ticket Deletion',
    icon: 'solar:trash-bin-trash-bold-duotone',
    permissions: ['TICKET:DELETE', 'TICKET_ASSIGNEES:DELETE', 'TICKET_STATUS:DELETE'],
  },
  DEPARTMENT_CONTROL: {
    label: 'pages.clientCredentialsPage.permissions.departmentControl',
    defaultLabel: 'Department Management',
    icon: 'solar:home-2-bold-duotone',
    permissions: [
      'DEPARTMENT:CREATE',
      'DEPARTMENT:READ',
      'DEPARTMENT:UPDATE',
      'DEPARTMENT:DELETE',
    ],
  },
  FORM_CONTROL: {
    label: 'pages.clientCredentialsPage.permissions.formControl',
    defaultLabel: 'Form Management',
    icon: 'solar:document-text-bold-duotone',
    permissions: [
      'FORM:CREATE',
      'FORM:READ',
      'FORM:UPDATE',
      'FORM:DELETE',
      'SHAREABLE_FORM:CREATE',
      'SHAREABLE_FORM:READ',
      'SHAREABLE_FORM:UPDATE',
      'SHAREABLE_FORM:DELETE',
    ],
  },
  USER_CONTROL: {
    label: 'pages.clientCredentialsPage.permissions.userControl',
    defaultLabel: 'User Management',
    icon: 'solar:users-group-two-rounded-bold-duotone',
    permissions: ['USER:CREATE', 'USER:READ', 'USER:UPDATE', 'USER:DELETE'],
  },
  ROLE_CONTROL: {
    label: 'pages.clientCredentialsPage.permissions.roleControl',
    defaultLabel: 'Roles & Permissions',
    icon: 'solar:shield-keyhole-bold-duotone',
    permissions: [
      'ROLES:CREATE',
      'ROLES:READ',
      'ROLES:UPDATE',
      'ROLES:DELETE',
      'PERMISSIONS:UPDATE',
    ],
  },
  CREDENTIALS_CONTROL: {
    label: 'pages.clientCredentialsPage.permissions.credentialsControl',
    defaultLabel: 'M2M Credentials',
    icon: 'solar:key-minimalistic-square-bold-duotone',
    permissions: [
      'CLIENT_CREDENTIALS:CREATE',
      'CLIENT_CREDENTIALS:READ',
      'CLIENT_CREDENTIALS:UPDATE',
      'CLIENT_CREDENTIALS:DELETE',
    ],
  },
  CSV_CONTROL: {
    label: 'pages.clientCredentialsPage.permissions.csvControl',
    defaultLabel: 'CSV Operations',
    icon: 'solar:import-bold-duotone',
    permissions: ['CSV:UPLOAD', 'CSV:DOWNLOAD'],
  },
  SCOPE_DEPARTMENT: {
    label: 'pages.clientCredentialsPage.permissions.scopeDepartment',
    defaultLabel: 'Scoped ABAC Access',
    icon: 'solar:globus-bold-duotone',
    permissions: ['TICKET:SCOPE_DEPARTMENT'],
  },
};

export const expandBundlesToPermissions = (selectedBundles) => {
  if (!selectedBundles || !Array.isArray(selectedBundles)) return [];
  const permissionsSet = new Set();
  selectedBundles.forEach((key) => {
    const bundle = PERMISSION_BUNDLES[key];
    if (bundle && bundle.permissions) {
      bundle.permissions.forEach((perm) => permissionsSet.add(perm));
    }
  });
  return Array.from(permissionsSet);
};

export const collapsePermissionsToBundles = (flatPermissions) => {
  if (!flatPermissions || !Array.isArray(flatPermissions)) return [];
  const permissionSet = new Set(flatPermissions);
  return Object.keys(PERMISSION_BUNDLES).filter((key) => {
    const bundle = PERMISSION_BUNDLES[key];
    return bundle.permissions.every((perm) => permissionSet.has(perm));
  });
};
